import { DualAxes } from '@ant-design/plots';
import utils from '../Common/utils';

const getColumnWidthRatio = (len) => {
  if (len < 2) return 0.1;
  if (len < 3) return 0.25;
  if (len < 5) return 0.5;
  if (len < 10) return 0.6;
  if (len < 15) return 0.7;
  return 0.8;
};

const IncomeVsExpenseBarChart = ({ data = [] }) => {
  const barData = data.flatMap(x => [
    { dt_str: x.dt_str, value: x.income, type: 'income' },
    { dt_str: x.dt_str, value: -Math.abs(x.expense), type: 'expense' },
  ]);

  const lineData = data.map(x => ({
    dt_str: x.dt_str,
    value: x.difference,
    type: 'difference',
  }));

  const config = {
    data: [barData, lineData],
    xField: 'dt_str',
    yField: ['value', 'value'], // shared Y-axis

    geometryOptions: [
      {
        geometry: 'column',
        isStack: true,
        seriesField: 'type',
        columnWidthRatio: getColumnWidthRatio(data.length),
        marginRatio: 0.1,
        color: ({ type }) =>
          type === 'income' ? 'green' :
          type === 'expense' ? 'red' :
          'transparent',
        label: {
          position: 'middle',
          content: datum =>
            datum.type !== 'difference' ? utils.formatToThousands(datum.value) : '',
          style: { fill: 'white', fontSize: 12 },
        },
      },
      {
        geometry: 'line',
        seriesField: 'type',
        smooth: false,
        lineStyle: {
          lineWidth: 2,
          dash: [4, 4],
        },
        color: '#1f77b4',
        label: false,
      },
    ],

    tooltip: {
      shared: true,
      formatter: (datum) => {
        if (datum.type === 'difference') {
          return {
            name: 'Δ Net diff',
            value: utils.formatToMoney(datum.value),
          };
        }
        return {
          name: datum.type,
          value: utils.formatToMoney(datum.value),
        };
      },
    },

    yAxis: {
      value: {
        title: {
          text: 'Amount (€)',
          style: { fill: 'grey', fontSize: 12 },
        },
        nice: true,
        sync: true,
        min: null,
        max: null,
        label: {
          formatter: (val) => utils.formatToThousands(val), // ✅ Y-axis formatter here
        },
      },
    },

    xAxis: {
      label: {
        autoHide: true,
        autoRotate: true,
      },
    },

    legend: {
      position: 'top',
      itemName: {
        formatter: name => {
          if (name === 'difference') return 'Δ Net diff';
          return name;
        },
      },
    },

    padding: 'auto',
  };

  return <DualAxes {...config} />;
};

export default IncomeVsExpenseBarChart;
